import { useHashScroll } from "@/hooks/useHashScroll";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import { brand } from "@/mocks/siteData";
import HeroSection from "./components/HeroSection";
import WhySection from "./components/WhySection";
import AgriTourismSection from "./components/AgriTourismSection";
import ExperiencesSection from "./components/ExperiencesSection";
import FarmsSection from "./components/FarmsSection";
import FarmersSection from "./components/FarmersSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ForFarmersSection from "./components/ForFarmersSection";
import HowItWorksSection from "./components/HowItWorksSection";
import AudiencesSection from "./components/AudiencesSection";
import FarmToPlateSection from "./components/FarmToPlateSection";
import StoriesSection from "./components/StoriesSection";
import SustainabilitySection from "./components/SustainabilitySection";
import WhyRythugaruSection from "./components/WhyRythugaruSection";
import ExploreSection from "./components/ExploreSection";
import VisionMissionSection from "./components/VisionMissionSection";
import JoinSection from "./components/JoinSection";
import NewsletterSection from "./components/NewsletterSection";
import FinalCtaSection from "./components/FinalCtaSection";

export default function Home() {
  useHashScroll();

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`${brand.name} Agri Tourism | Farm Experiences in Konaseema`}
        description="Experience the life behind your food — book authentic farm and village experiences with real farmers across Konaseema, Andhra Pradesh, India."
        path="/"
        keywords="agri tourism, farm experience India, Konaseema tourism, village life experience, farm visit Andhra Pradesh, farmer stories, rural tourism"
        image="https://readdy.ai/api/search-image?query=Sunlit%20green%20paddy%20fields%20and%20coconut%20groves%20of%20a%20rural%20Indian%20village%20at%20sunrise%2C%20a%20farmer%20walking%20a%20field%20bund%2C%20fresh%20vivid%20green%20tones%2C%20warm%20golden%20sunlight%2C%20cinematic%20landscape%2C%20ultra%20detailed&width=1920&height=1080&seq=home-og-cover&orientation=landscape"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: `${brand.fullName}`,
          description:
            "Authentic farm and village experiences with real farmers across Konaseema, Andhra Pradesh, India.",
          inLanguage: "en",
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <WhySection />
        <AgriTourismSection />
        <ExperiencesSection />
        <FarmsSection />
        <FarmersSection />
        <TestimonialsSection />
        <ForFarmersSection />
        <HowItWorksSection />
        <AudiencesSection />
        <FarmToPlateSection />
        <StoriesSection />
        <SustainabilitySection />
        <WhyRythugaruSection />
        <ExploreSection />
        <VisionMissionSection />
        <JoinSection />
        <NewsletterSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}